import { ref, watch, onMounted, onActivated } from 'vue'
import { useI18n } from 'vue-i18n'
import { toBeijingTime } from '@/utils/timeFormat'
import type { IndexEchart, BarChartData } from '@/types/index'
import { chanceSaleList, userList, sourceList } from '@/api/overseasSales/index'

export default function barEChartData(formState: BarChartData) {
  const { t } = useI18n()
  const principalStatistics = ref<IndexEchart.BarData>()
  const businessAmount = ref<IndexEchart.BarData>()
  const cueSourceStatistics = ref<IndexEchart.BarData>()

  const getSaleData = async () => {
    try {
      const res = await chanceSaleList({
        ...formState.chanceSales
      })

      const xAxisD = getXaxis(res.data, 'countTime')
      const yAxisD = getYaxis(res.data, 'salesAmount')
      businessAmount.value = {
        legendArr: ['商机金额(万元)'],
        xAxisData: xAxisD,
        seriesArr: [
          {
            name: '商机金额(万元)',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisD
          }
        ]
      }
      // console.log('xAxisD: ', xAxisD)
    } catch (error) {
      businessAmount.value = {
        legendArr: ['商机金额(万元)'],
        xAxisData: [],
        seriesArr: [
          {
            name: '商机金额(万元)',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.chanceSales,
    () => {
      getSaleData()
    },
    { deep: true, immediate: true }
  )
  const getUserata = async () => {
    try {
      const res = await userList({
        ...formState.userList,
        startTime: toBeijingTime(formState.userList.startTime),
        endTime: toBeijingTime(formState.userList.endTime)
      })
      const xAxisCustomer = getXaxis(res.data, 'userName')
      const yAxisDCustomer = getYaxis(res.data, 'customerCount')
      const yAxisDClue = getYaxis(res.data, 'clueCount')
      const yAxisDChance = getYaxis(res.data, 'chanceCount')
      const yAxisDFollow = getYaxis(res.data, 'followCount')

      principalStatistics.value = {
        legendArr: [t('home.2elm35'), t('home.q9wxf8'), t('home.4z5hih'), t('home.9onhsr')],
        xAxisData: xAxisCustomer,

        seriesArr: [
          {
            name: t('home.2elm35'),
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisDCustomer
          },
          {
            name: t('home.q9wxf8'),
            type: 'bar',
            itemStyle: {
              color: '#877CED'
            },
            data: yAxisDClue
          },
          {
            name: t('home.4z5hih'),
            type: 'bar',
            itemStyle: {
              color: '#36C8E1'
            },
            data: yAxisDChance
          },
          {
            name: t('home.9onhsr'),
            type: 'bar',
            itemStyle: {
              color: '#FFB648'
            },
            data: yAxisDFollow
          }
        ]
      }
    } catch (error) {
      principalStatistics.value = {
        legendArr: ['客户', '线索', '商机', '跟进数'],
        xAxisData: [],
        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.userList,
    () => {
      getUserata()
    },
    { deep: true, immediate: true }
  )
  const getCuledata = async () => {
    try {
      const res = await sourceList({
        ...formState.clueData,
        startTime: toBeijingTime(formState.clueData.startTime),
        endTime: toBeijingTime(formState.clueData.endTime)
      })
      const xAxisCustomer = getXaxis(res.data, 'source')
      const yAxisDCustomer = getYaxis(res.data, 'customerCount')
      const yAxisDClue = getYaxis(res.data, 'clueCount')
      const yAxisDChance = getYaxis(res.data, 'chanceCount')
      const yAxisDFollow = getYaxis(res.data, 'followCount')

      cueSourceStatistics.value = {
        legendArr: [t('home.2elm35'), t('home.q9wxf8'), t('home.4z5hih'), t('home.9onhsr')],
        xAxisData: xAxisCustomer,
        seriesArr: [
          {
            name: t('home.2elm35'),
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: yAxisDCustomer
          },
          {
            name: t('home.q9wxf8'),
            type: 'bar',
            itemStyle: {
              color: '#877CED'
            },
            data: yAxisDClue
          },
          {
            name: t('home.4z5hih'),
            type: 'bar',
            itemStyle: {
              color: '#36C8E1'
            },
            data: yAxisDChance
          },
          {
            name: t('home.9onhsr'),
            type: 'bar',
            itemStyle: {
              color: '#FFB648'
            },
            data: yAxisDFollow
          }
        ]
      }
    } catch (error) {
      cueSourceStatistics.value = {
        legendArr: ['客户'],
        xAxisData: [],
        seriesArr: [
          {
            name: '客户',
            type: 'bar',
            itemStyle: {
              color: '#3F97FF'
            },
            data: []
          }
        ]
      }
      console.log('getSaleDataerror: ', error)
    }
  }
  watch(
    () => formState.clueData,
    () => {
      getCuledata()
    },
    { deep: true, immediate: true }
  )
  onActivated(() => {
    getCuledata()
    getSaleData()
    getUserata()
  })
  onMounted(() => {
    // getSaleData()
  })
  return { principalStatistics, businessAmount, cueSourceStatistics }
}
function getXaxis(data: any, valueName: string) {
  const arr: string[] = []
  if (data.length > 0) {
    data.forEach((item: any) => {
      arr.push(item[valueName] as never)
    })
  } else {
    return []
  }

  return arr
}
function getYaxis(data: any, valueName: string) {
  const arr: number[] = []
  if (data.length > 0) {
    data.forEach((item: any) => {
      arr.push(item[valueName] as never)
    })
  } else {
    return []
  }

  return arr
}
